module.exports = __webpack_public_path__ + "img/home-img-travel-1.d83f0768.jpg";